import React, { useState } from 'react';
import './pageControlLogin.css';

const PageControlLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yuccan.tech';

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!credentials.username || !credentials.password) {
      setError('Please enter both username and password');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      console.log('DEBUG: Attempting login to:', `${API_BASE_URL}/api/auth/login`);
      console.log('DEBUG: Login credentials:', { username: credentials.username, password: '***' });

      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      });

      console.log('DEBUG: Login response status:', response.status, response.statusText);

      const result = await response.json();
      console.log('DEBUG: Login response result:', result);

      if (result.success) {
        // Store token in localStorage
        localStorage.setItem('admin_token', result.token);
        localStorage.setItem('admin_expires', Date.now() + result.expiresIn);
        
        console.log('DEBUG: Token saved to localStorage:', result.token.substring(0, 8) + '...');
        console.log('DEBUG: Calling onLogin callback');
        
        // Notify parent component
        onLogin(result.token);
      } else {
        console.log('DEBUG: Login failed with message:', result.message);
        setError(result.message || 'Login failed');
      }
    } catch (err) {
      console.log('DEBUG: Login error:', err);
      setError('Connection error. Please check if the server is running.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="page-control-login-container">
      <div className="page-control-login-box">
        <div className="page-control-login-header">
          <h1>🔐 Page Control Login</h1>
          <p>CyberElectrix Content Management</p>
        </div>

        {error && (
          <div className="error-message">
            ❌ {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="page-control-login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              placeholder="Enter username"
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter password"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className="page-control-login-btn"
            disabled={loading}
          >
            {loading ? '🔄 Logging in...' : 'Access Page Controls'}
          </button>
        </form>

        <div className="page-control-login-info">
          <p><strong>Default Credentials:</strong></p>
          <p>Username: <code>admin</code></p>
          <p>Password: <code>CyberElectrix2024!</code></p>
          <p className="security-note">
            🔒 Change these credentials in production via environment variables
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageControlLogin;